import { render } from "./RestablecerContraseña.vue?vue&type=template&id=7b6cabd8&scoped=true"
import script from "./RestablecerContraseña.vue?vue&type=script&lang=js"
export * from "./RestablecerContraseña.vue?vue&type=script&lang=js"

import "./RestablecerContraseña.vue?vue&type=style&index=0&id=7b6cabd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b6cabd8"]])

export default __exports__